"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./ButtonGroup.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ButtonGroup = function ButtonGroup(_ref) {
  var responsive = _ref.responsive,
      className = _ref.className,
      children = _ref.children;
  var wrapperClass = 'button-group';
  if (responsive) wrapperClass += ' button-group--responsive';
  if (className) wrapperClass += " ".concat(className);
  return _react.default.createElement("div", {
    className: wrapperClass
  }, children);
};

ButtonGroup.defaultProps = {
  responsive: false,
  className: ''
};
ButtonGroup.propTypes = {
  /** Classes adicionais para wrapper */
  className: _propTypes.default.string,

  /** HTML ou texto inserido dentro do componente */
  children: _propTypes.default.node,

  /** Modifica o formato de exibição conforme os breakpoints */
  responsive: _propTypes.default.bool
};
var _default = ButtonGroup;
exports.default = _default;